<p-sidebar [(visible)]="appMain.rightMenuActive" (onShow)="onSidebarOpen()" (onHide)="onSidebarHide()" [position]="app.isRTL ? 'left' : 'right'" [blockScroll]="true" [showCloseIcon]="false" [autoZIndex]="false" [baseZIndex]="1000" [styleClass]="'layout-rightmenu p-sidebar-right fs-small py-3 ' + (app.isRTL ? 'pl-1 pr-1' : 'pl-1 pr-1')"
           [style]="{zIndex:6102}"
>
  <div class="next-events">
    <h6 class="header font-semibold mb-2" [ngClass]="{'ml-3': !app.isRTL, 'mr-3': app.isRTL}">{{ 'common.calendar' | translate | uppercase }}</h6>
      <full-calendar [events]="eventInputs" [options]="calendarOptions()"></full-calendar>
    <!--        <ul>-->
    <!--            <li><i class="pi pi-eye" [ngClass]="{'mr-3': !app.isRTL, 'ml-3': app.isRTL}"></i>A/B Test</li>-->
    <!--            <li><i class="pi pi-video" [ngClass]="{'mr-3': !app.isRTL, 'ml-3': app.isRTL}"></i>Video Shoot</li>-->
    <!--            <li><i class="pi pi-sitemap" [ngClass]="{'mr-3': !app.isRTL, 'ml-3': app.isRTL}"></i>Board Meeting</li>-->
    <!--            <li><i class="pi pi-compass" [ngClass]="{'mr-3': !app.isRTL, 'ml-3': app.isRTL}"></i>Q4 Planning</li>-->
    <!--            <li><i class="pi pi-palette" [ngClass]="{'mr-3': !app.isRTL, 'ml-3': app.isRTL}"></i>Design Training</li>-->
    <!--        </ul>-->
  </div>
    <div class="online-members flex flex-column mt-3" [ngClass]="{'ml-3': !app.isRTL, 'mr-3': app.isRTL}">
        <h6 class="header font-semibold">{{ 'shared.rightmenu.online_members' | translate | uppercase }}</h6>
        <div class="flex flex-row flex-wrap" *ngIf="!onlineUsersLoading && onlineUsersAvailable">
            <app-thumbnail *ngFor="let user of onlineUsersVisible"
                           classList="m-1"
                           size="md"
                           [circle]="true"
                           [bordered]="true"
                           stylesList="width: 32px; height: 32px;"
                           (click)="navigateToUser(user)"
                           [imgSrc]="user.avatar | mediaObject: {defaultImageType: 'avatar'}">
            </app-thumbnail>
        </div>
        <small *ngIf="!onlineUsersLoading && !onlineUsersAvailable" class="text-color-secondary">{{ 'realtime.unavailable' | translate }}</small>
        <div class="flex flex-row flex-wrap" *ngIf="onlineUsersLoading">
            <p-skeleton *ngFor="let _ of onlineUsersSkeletons" styleClass="m-1"
                        [style]="{width: '32px', height: '32px', borderRadius: '999px'}"></p-skeleton>
        </div>
        <span class="mt-3" *ngIf="onlineUsersAvailable && onlineUsersExtraCount > 0"><b>+{{ onlineUsersExtraCount }}</b> {{ 'shared.rightmenu.users' | translate }}</span>
    </div>
</p-sidebar>
